import React, { useEffect, useRef, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import s from "./OtherCountriesRestrictions.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getCountriesList,
  getCountryDetails,
} from "../../redux/InformationSlice";
import { Link, useParams } from "react-router-dom";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import InCountry from "../../Components/InCountry/InCountry";
import { useForm } from "antd/es/form/Form";
import { Form, Select } from "antd";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

const OtherCountriesRestrictions = () => {
  const data = useSelector(
    (state: RootState) => state.info.otherCountriesDeportationDetails,
  );

  const params = useParams();
  const dispatch: AppDispatch = useDispatch();
  const [form] = useForm();
  const countries = useSelector((state: RootState) => state.info.countries);
  const country = useSelector((state: RootState) => state.info.countryDetails);
  const [countryId, setCountryId] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getCountriesList());
    dispatch(
      getCountryDetails({
        country_id: Number(countryId ? countryId : undefined),
      }),
    );
  }, [params]);

  const [search, setSearch] = useState("");

  const filteredCountries = countries?.filter((it) =>
    it.country_name.toLowerCase().includes(search.toLowerCase()),
  );
  const { width } = useWindowDimensions();
  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Ограничениях на въезд для мигрантов, живущих с ВИЧ"
        description="Ограничениях на въезд для мигрантов, живущих с ВИЧ - информация по всем странам мира"
        url="https://www.vputi.org/restrictions"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство других стран / Узнай больше об ограничениях",
            path: "/otherCountries",
          }}
        />
        <ContactButtons />
        <div className={s.restrictions}>
          <div className={s.restriction_image}>
            <img src="/images/Limitation.svg" className={s.restrictions_img} />
          </div>
          <div className={s.restriction_text}>
            <div className={s.restriction_title}>
              {t(
                "Узнай больше об ограничениях на въезд для мигрантов, живущих с ВИЧ",
              )}
            </div>
            <div className={s.restriction_description}>
              {t(
                "Некоторые страны налагают ограничение на въезд и долгосрочное пребывание для иностранцев, живущих с ВИЧ. Ниже вы можете найти информацию по странам со ссылкой на дополнительные источники информации.",
              )}
            </div>
            <div className={s.yellow_wrapper}>
              <strong>
                {t(
                  "Пожалуйста, учтите, что информация носит справочный характер!",
                )}
              </strong>{" "}
              {t(
                "За дополнительными сведениями лучше обратиться в посольство страны, в которую вы направляетесь",
              )}
            </div>
            <div className={s.form}>
              <Form.Item name="shipper_country">
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className={s.select}
                  // defaultValue={countries?.[0]?.id}
                  options={countries?.map((it) => ({
                    value: it?.id,
                    label: it?.country_name,
                  }))}
                  placeholder={t("ВЫБРАТЬ СТРАНУ")}
                  onSelect={(value) => {
                    dispatch(getCountryDetails({ country_id: value }));
                    setCountryId(value);
                  }}
                />
              </Form.Item>
            </div>
          </div>
        </div>
        {country && countryId ? (
          <div className={s.restriction_details}>
            <div className={s.country_name}>{country?.country_name}</div>
            <div className={s.restriction_item}>
              <div className={s.item_title}>{t("Ограничение на Въезд")}</div>
              <div
                className={s.item_description}
                dangerouslySetInnerHTML={{
                  __html: country?.entry_restriction ?? "",
                }}
              ></div>
            </div>
            <div className={s.restriction_item}>
              <div className={s.item_title}>
                {t("Ограничение на краткосрочное пребывание")}
              </div>
              <div
                className={s.item_description}
                dangerouslySetInnerHTML={{
                  __html: country?.short_term_stay_restriction ?? "",
                }}
              ></div>
            </div>
            <div className={s.restriction_item}>
              <div className={s.item_title}>
                {t("Ограничение на долгосрочное пребывание")}
              </div>
              <div
                className={s.item_description}
                dangerouslySetInnerHTML={{
                  __html: country?.long_term_stay_restriction ?? "",
                }}
              ></div>
            </div>

            <div className={s.restriction_item}>
              <div className={s.item_title}>
                {t("Ссылка на дополнительную информацию")}
              </div>

              {country?.additional_info_link && (
                <Link
                  to={country.additional_info_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={s.link}
                >
                  {country.additional_info_link}
                </Link>
              )}
            </div>
          </div>
        ) : null}
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default OtherCountriesRestrictions;
